// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckCircleOutlinedSvg from "@fishx/icons-svg/es/asn/CheckCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleOutlinedSvg
  }));
};

CheckCircleOutlined.displayName = 'CheckCircleOutlined';
export default React.forwardRef(CheckCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CheckCircleOutlined.js
// module id = 2187
// module chunks = 0